module.exports = __webpack_public_path__ + "res/33-img_game_bg_t.8aa0b44af2109bf02e07fd4e0505581a.png";